import styled from 'styled-components';

const TeamMemberStyles = styled.div`
  cursor: pointer;
  text-align: left;
  background-color: var(--color-sand);

  .name,
  .job-title,
  .offices {
    margin: 0;
    text-transform: none;
  }

  .job-title {
    font-weight: var(--font-weight-regular);
    opacity: 0.6;
  }

  .name {
    font-weight: var(--font-weight-medium);
    transition: color 0.4s;
    transition-delay: 0.1s;
  }

  .offices {
    margin-top: 0.4rem;
    margin-bottom: 4rem;
    font-weight: var(--font-weight-regular);
    opacity: 0.4;
  }

  .btn-group {
    margin-top: 2rem;
    justify-content: flex-start;
    gap: 1rem;
  }

  .top {
    position: relative;

    .headshot {
      width: 100%;
      height: 12rem;

      img {
        object-position: top;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: flex-end;
      flex-direction: row;
      width: 100%;
      height: 100%;
      padding: 2rem;
      opacity: 0;
      pointer-events: none;
      color: var(--color-white);
      background-color: rgba(160, 152, 143, 0.5);
      transition: opacity 0.4s;
    }
  }

  .bottom {
    padding: 1.5rem;
    text-align: left;

    .view-bio {
      margin: 1rem 0 0;
    }
  }

  &:hover,
  &:focus {
    .top .overlay {
      opacity: 1;
      pointer-events: initial;
    }

    .bottom .name {
      color: var(--color-bark);
    }

    .view-bio {
      color: var(--color-charcoal);
    }
  }

  .modal {
    .job-title {
      font-weight: var(--font-weight-medium);
      opacity: 1;
    }

    .headshot {
      width: 40%;
      aspect-ratio: 1/1;
      margin: 0 2rem 1rem 0;
      float: left;
    }
  }

  @media (min-width: 500px) {
    .top .headshot {
      height: 14rem;
    }
  }

  @media (min-width: 768px) {
    .top .headshot {
      height: 18rem;
    }

    .modal {
      .name,
      .offices {
        font-size: 1.1rem;
      }
    }
  }

  @media (min-width: 992px) {
    .modal {
      .name,
      .offices {
        font-size: 1.25rem;
      }
    }
  }

  @media (min-width: 1400px) {
    .top .headshot {
      height: 20rem;
    }
  }
`;

export default TeamMemberStyles;
